// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_61-4";
export var collapsed = "_61-1";
export var headerBar = "_61-0";
export var leftHeaderContent = "_61-3";
export var subjectContainer = "_61-2";